import React, { useEffect, useState } from "react";

// route
import { useParams } from "react-router";

// api
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";

// icon
import NoConversation from "../../assets/images/no-conversation-vector.svg";

// component
import Header from "../common/header/Header";
import ChatList from "./chat-list";
import ChatBody from "./chat-body";

// store
import { useDispatch, useSelector } from "react-redux";
import { getTrailsName } from "../../reducer/slices/trial/get-trial-name-slice";
import { setCallData } from "../../reducer/slices/twilio-calls/call-slice";

const Conversation = () => {
  const { id } = useParams();
  const [call, setCall] = useState(false);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [showClose, setShowClose] = useState(false);
  const [trialInfo, setTrialInfo] = useState(null);
  const [latestmessage, setLatestmessage] = useState(null);
  const POLLING_INTERVAL = 5000; // Poll every 5 seconds
  const [noRecruiter, setNoRecruiter] = useState(false);
  const [conversation, setConversation] = useState([]);
  const user = useSelector((state) => state.user);
  const [selectedChatId, setSelectedChatId] = useState(id);

  useEffect(() => {
    dispatch(getTrailsName({}));
  }, []);

  const fetchConversationData = async () => {
    try {
      axios
        .get(
          `${ENDPOINTS.CONVERSATION.GET_CONVERSATION_BY_TRIAL_ID}?patientTrialJuncId=${id}`
        )
        .then((res) => {
          const response = res;
          console.log("response in conversation", response);
          setTrialInfo({
            patientName: res.data.data.patientName,
            phoneNumber: res.data.data.phoneNumber,
            status: res.data.data.status,
            trialID: res.data.data.trialID,
            patientID: res.data.data.patientID,
            patientTrialJuncID: res.data.data.patientTrialJuncID,
            trialName: res.data.data.trialName,
            isChatByBot: res.data.data.isChatByBot,
            docuSignStatus: res.data.data.docuSignStatus,
            // iSeclinProSync: res.data.data.iSeclinProSync,
            // eclinProSyncResult: res.data.data.eclinProSyncResult,
            // eclinProSyncStatus: res.data.data.eclinProSyncStatus,
          });
          if (res?.data?.data?.patientConversationNodes != null && res?.data?.data?.patientConversationNodes?.length > 0) {
            setConversation(res.data.data.patientConversationNodes);
          } else {
            setConversation([]);
          }
          setCall(false);
          setNoRecruiter(false);
        })
        .catch((error) => {
          if (
            error &&
            error.response &&
            error.response.status &&
            error.response.status === 400
          ) {
            setNoRecruiter(true);
          }
          if (
            error &&
            error.response &&
            error.response.status &&
            error.response.status === 500
          ) {
            setNoRecruiter(true);
          }
        });
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 400
      ) {
        setNoRecruiter(true);
      }
      if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 500
      ) {
        setNoRecruiter(true);
      }
    }
  };

  useEffect(() => {
    fetchConversationData();
    const interval = setInterval(() => {
      fetchConversationData();
    }, POLLING_INTERVAL); // Poll every 5 seconds

    return () => clearInterval(interval);
  }, [selectedChatId]);
  function getLastMessageExcludingCallLog(messages) {
    const filteredMessages = messages.filter((msg) => msg.sender !== "CallLog");

    if (filteredMessages.length === 0) return null;

    const lastMessage = filteredMessages.reduce((latest, msg) => {
      return new Date(msg.createdAt) > new Date(latest.createdAt)
        ? msg
        : latest;
    });

    return lastMessage;
  }
  useEffect(() => {
    if (conversation) {
      const lastMsg = getLastMessageExcludingCallLog(conversation);
      setLatestmessage(lastMsg);
    }
  }, [conversation]);

  useEffect(() => {
    if (call) {
      fetchConversationData();
    }
  }, [call]);

  const onSearchClick = () => {};

  const onCloseClick = () => {
    setSearch("");
    setShowClose(false);
  };

  const [status, setStatus] = useState("Calling");

  const handleCall = async (phoneNumber) => {
    if (!phoneNumber) {
      return;
    }

    dispatch(
      setCallData({
        params: {
          To: phoneNumber,
          PatientID: trialInfo.patientID,
          PatientTrialJuncID: trialInfo.patientTrialJuncID,
          UserID: user.userProfile.userID,
        },
        trialInfo,
        call: true,
        route: `/conversations/${trialInfo.patientTrialJuncID}`,
      })
    );
  };

  useEffect(() => {
    setSelectedChatId(id);
  }, [id]);

  return (
    <>
      <Header
        backbutton={true}
        headertitle="Conversations"
        showClose={showClose}
        isSearch={true}
        search={search}
        setSearch={setSearch}
        onSearchClick={onSearchClick}
        onCloseClick={onCloseClick}
      />
      {noRecruiter === true ? (
        <div className="h-[calc(100vh-80px)] w-full flex flex-col items-center justify-center no-conversation actual-img-ratio">
          <img src={NoConversation} alt="" />
          <p className="mt-1 text-sm font-medium">No Conversations yet</p>
        </div>
      ) : (
        <div className="flex flex-row justify-content  h-[calc(100vh-88px)]">
          <ChatList trialInfo={trialInfo} latestmessage={latestmessage} />

          <ChatBody
            handleCall={handleCall}
            trialInfo={trialInfo}
            id={selectedChatId}
            conversation={conversation}
            trialName={trialInfo}
            setLatestmessage={setLatestmessage}
            // iSeclinProSync={trialInfo?.iSeclinProSync || trialInfo?.eclinProSyncStatus === "failed" ? true : false}
            // eclinProSyncStatus={trialInfo?.eclinProSyncStatus}
            // eclinProSyncResult={trialInfo?.eclinProSyncResult}
          />
        </div>
      )}
    </>
  );
};

export default Conversation;
